import React from 'react'
import RouteWithSubRoutes from './components/RouteWithSubRoutes'

import ROUTES from './config/routes'

const Routes = () =>
  ROUTES.map((route, index) => (
    <RouteWithSubRoutes key={index} {...route} />
  ))

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes/index.js